import { VimeoEmbedParameters } from '@vimeo/player';

export const VIDEO_VARIANTS = {
  VideoWithText: 'videoWithText',
  VideoWithoutText: 'videoWithoutText',
  ImageVideoWithText: 'imageVideoWithText',
} as const;

export type VideoVariant = (typeof VIDEO_VARIANTS)[keyof typeof VIDEO_VARIANTS];

export const defaultVimeoPlayerOptions: Omit<VimeoEmbedParameters, 'id'> = {
  title: false,
  byline: false,
  portrait: false,
  vimeo_logo: false,
  controls: true,
  muted: false,
  color: '#CD1543',
};
export const backgroundVimeoPlayerOptions: Omit<VimeoEmbedParameters, 'id'> = {
  color: '#CD1543',
  controls: true,
};

// Specific options for ImageVideoWithText: muted, looping, no controls
export const imageVideoWithTextVimeoOptions: Omit<VimeoEmbedParameters, 'id'> = {
  muted: true,
  loop: true,
  controls: false,
  color: '#CD1543',
};

export const DEFAULT_IMAGE_QUALITY = 80;
export const DEFAULT_IMAGE_WIDTH = 500;
